import getConfig from 'next/config';
import Head from 'next/head';
import { useEffect } from 'react';

import { useUser } from '../../store/hooks/users';
import { useUserChangeHandler } from '../../store/hooks/useUserChangeHandler';

import { gib } from './utils';

interface IFHPScriptProps {
  sessionId?: string;
}

export const FHPScript = ({ sessionId }: IFHPScriptProps) => {
  const backUrl = '//fp-back.facct.ru/api/fl';

  const user = useUser();

  useEffect(() => {
    gib.setAttribute('gclientID', window.__AF__.gclientID);
    gib.setAttribute('yclientID', window.__AF__.yclientID);
  }, []);

  useEffect(() => {
    sessionId && gib.setSessionID(sessionId);
  }, [sessionId]);

  useUserChangeHandler(user, (_user) => {
    gib.setIsAuthorized();
    gib.setLogin(_user.sub);
  });

  return (
    <Head>
      <script src="https://s91588.cdn.ngenix.net/shared/static/js/Gbt4kxd8Em4r6Nn.js" />
      <script
        dangerouslySetInnerHTML={{
          __html: `window.gib.init({cid:"gib-w-${
            getConfig().publicRuntimeConfig.antiFraudFhpCid
          }", backUrl:"${backUrl}"})`,
        }}
      />
    </Head>
  );
};
